import { render, staticRenderFns } from "./CBreadcrumbs.vue?vue&type=template&id=368fa448&"
import script from "./CBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./CBreadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports